/** Catalog Setting keys — global ops policy for stock / expiry alerts. */
export const LOW_STOCK_THRESHOLD_KEY = 'LOW_STOCK_THRESHOLD';
export const NEAR_EXPIRY_WARN_DAYS_KEY = 'NEAR_EXPIRY_WARN_DAYS';

export const DEFAULT_LOW_STOCK_THRESHOLD = 10;
export const DEFAULT_NEAR_EXPIRY_WARN_DAYS = 30;

export type StockAlertGlobals = {
  lowStockThreshold: number;
  nearExpiryWarnDays: number;
};

/** Parse a Setting.value into a non-negative int; invalid → fallback. */
export function parseStockAlertInt(value: string | null | undefined, fallback: number): number {
  if (value == null || String(value).trim() === '') return fallback;
  const n = Number.parseInt(String(value).trim(), 10);
  if (!Number.isFinite(n) || n < 0) return fallback;
  return n;
}

export function resolveLowStockThreshold(
  productOverride: number | null | undefined,
  global: number,
): number {
  if (productOverride == null || !Number.isFinite(Number(productOverride))) return global;
  return Math.max(0, Number(productOverride));
}

export function resolveNearExpiryWarnDays(
  productOverride: number | null | undefined,
  global: number,
): number {
  if (productOverride == null || !Number.isFinite(Number(productOverride))) return global;
  return Math.max(0, Number(productOverride));
}

export function stockAlertGlobalsFromRows(
  rows: Array<{ key: string; value: string }>,
): StockAlertGlobals {
  const byKey = new Map(rows.map((r) => [r.key, r.value]));
  return {
    lowStockThreshold: parseStockAlertInt(byKey.get(LOW_STOCK_THRESHOLD_KEY), DEFAULT_LOW_STOCK_THRESHOLD),
    nearExpiryWarnDays: parseStockAlertInt(
      byKey.get(NEAR_EXPIRY_WARN_DAYS_KEY),
      DEFAULT_NEAR_EXPIRY_WARN_DAYS,
    ),
  };
}
